/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_AfterInputs */



/**
* | output |
* | --- |
* | "Event After" |
*
* @param {Event_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_after = /** @type {((inputs?: Event_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événement après")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach der Veranstaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento dopo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие после")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento después")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件之后")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント後")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना के बाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento após")
	return /** @type {LocalizedString} */ ("Event After")
});